var _defs, _g, _g2, _g3, _g4, _g5, _text, _text2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSlider2 = function SvgSlider2(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 929.5 480.1"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "slider2_svg__a",
    width: 123.713,
    height: 122.7,
    x: 805.787,
    y: 58,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "blur",
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.114
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "blur",
    operator: "in"
  }), /*#__PURE__*/React.createElement("feComposite", {
    "in": "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    "data-name": "Group 48335"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M.528 68.2V479",
    "data-name": "Path 45615"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.138 68.2V479",
    "data-name": "Path 45616"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.407 68.2V479",
    "data-name": "Path 45617"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.838 68.2V479",
    "data-name": "Path 45618"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.488 68.2V479",
    "data-name": "Path 45619"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M433.818 68.2V479",
    "data-name": "Path 45620"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M521.148 68.2V479",
    "data-name": "Path 45621"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M606.798 68.2V479",
    "data-name": "Path 45622"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M694.128 68.2V479",
    "data-name": "Path 45623"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M782.518 68.2V479",
    "data-name": "Path 45624"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M868.787 68.2V479",
    "data-name": "Path 45625"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "#e6e6e6",
    "data-name": "Group 48336"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M134.689 185.843h784.926",
    "data-name": "Path 45626"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.689 286.315h784.926",
    "data-name": "Path 45627"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.689 389.128h784.926",
    "data-name": "Path 45628"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.681 479.6h783.934",
    "data-name": "Path 45629"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 48342"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 58430"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 48368"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#f1ad0f",
    stroke: "#fff",
    d: "M676.344 93H135.217v24.885h541.127c1.039-17.873.322-7.428 0-24.885Z",
    "data-name": "Path 45633"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#333",
    "data-name": "63%",
    fontFamily: "Poppins-Regular, Poppins",
    fontSize: 18,
    transform: "translate(727 112.698)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -33.642,
    y: 0
  }, "63%"))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 48366"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    d: "M476.237 119.862h-341.02v24.885h341.02c.614-20.1.614-6.3 0-24.885Z",
    "data-name": "Path 45637"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#333",
    "data-name": "34%",
    fontFamily: "Poppins-Regular, Poppins",
    fontSize: 18,
    transform: "translate(528 140.698)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -33.624,
    y: 0
  }, "34%"))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 48367"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#727272",
    stroke: "#fff",
    d: "M361.673 147.862H135.217v24.885h226.456c0-18.249-.208-4.355 0-24.885Z",
    "data-name": "Path 45641"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#333",
    "data-name": "22%",
    fontFamily: "Poppins-Regular, Poppins",
    fontSize: 18,
    transform: "translate(410 167.836)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -32.274,
    y: 0
  }, "22%")))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 58429"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 48369"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#f1ad0f",
    stroke: "#fff",
    d: "M769.05 196.001H135.111v24.885H769.05c1.217-17.873.377-7.428 0-24.885Z",
    "data-name": "Path 45633"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#333",
    "data-name": "76%",
    fontFamily: "Poppins-Regular, Poppins",
    fontSize: 18,
    transform: "translate(818.894 215.227)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -32.148,
    y: 0
  }, "76%"))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 48370"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    d: "M610.436 222.864H135.217v24.885h475.219c.856-20.1.856-6.3 0-24.885Z",
    "data-name": "Path 45637"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#333",
    "data-name": "54%",
    fontFamily: "Poppins-Regular, Poppins",
    fontSize: 18,
    transform: "translate(661 242.228)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -34.11,
    y: 0
  }, "54%"))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 48371"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#727272",
    stroke: "#fff",
    d: "M184.158 249.727h-48.941v24.885h48.941c0-18.249-.041-4.355 0-24.885Z",
    "data-name": "Path 45641"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#333",
    "data-name": "3%",
    fontFamily: "Poppins-Regular, Poppins",
    fontSize: 18,
    transform: "translate(223 270.228)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -22.464,
    y: 0
  }, "3%")))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 58428"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 48372"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#f1ad0f",
    stroke: "#fff",
    d: "M719.717 299h-584.5v24.885h584.5c1.125-17.873.35-7.428 0-24.885Z",
    "data-name": "Path 45633"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#333",
    "data-name": "86%",
    fontFamily: "Poppins-Regular, Poppins",
    fontSize: 18,
    transform: "translate(771.548 318.754)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -34.29,
    y: 0
  }, "86%"))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 48373"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    d: "M640.258 325.862H135.217v24.885h505.041c.909-20.1.909-6.3 0-24.885Z",
    "data-name": "Path 45637"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#333",
    "data-name": "56%",
    fontFamily: "Poppins-Regular, Poppins",
    fontSize: 18,
    transform: "translate(691 345.754)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -34.128,
    y: 0
  }, "56%"))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 48374"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#727272",
    stroke: "#fff",
    d: "M273.745 352.724H135.217v24.885h138.528c0-18.249-.128-4.355 0-24.885Z",
    "data-name": "Path 45641"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#333",
    "data-name": "9%",
    fontFamily: "Poppins-Regular, Poppins",
    fontSize: 18,
    transform: "translate(311 371.754)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -22.806,
    y: 0
  }, "9%")))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 58431"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 48375"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#f1ad0f",
    stroke: "#fff",
    d: "M810.874 400H135.217v24.885h675.657c1.297-17.873.402-7.428 0-24.885Z",
    "data-name": "Path 45633"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#333",
    "data-name": "91%",
    fontFamily: "Poppins-Regular, Poppins",
    fontSize: 18,
    transform: "translate(855.548 419.6)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -27.972,
    y: 0
  }, "91%"))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 48376"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    d: "M687.176 426.862H134.89v24.885h552.286c.994-20.1.994-6.3 0-24.885Z",
    "data-name": "Path 45637"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#333",
    "data-name": "79%",
    fontFamily: "Poppins-Regular, Poppins",
    fontSize: 18,
    transform: "translate(735.018 446.6)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -31.914,
    y: 0
  }, "79%"))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 48377"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#727272",
    stroke: "#fff",
    d: "M406.466 453.725H135.217v24.885h271.249c0-18.249-.249-4.355 0-24.885Z",
    "data-name": "Path 45641"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#333",
    "data-name": "32%",
    fontFamily: "Poppins-Regular, Poppins",
    fontSize: 18,
    transform: "translate(455 473.6)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -32.67,
    y: 0
  }, "32%")))))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    fill: "#333",
    "data-name": "Group 48365",
    fontFamily: "Poppins-Regular, Poppins",
    fontSize: 20
  }, /*#__PURE__*/React.createElement("text", {
    transform: "translate(86 133)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -62.64,
    y: 0
  }, "LATAM")), /*#__PURE__*/React.createElement("text", {
    transform: "translate(85 246)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -84.62,
    y: 0
  }, "America")), /*#__PURE__*/React.createElement("text", {
    transform: "translate(86 360)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -53.16,
    y: 0
  }, "APAC")), /*#__PURE__*/React.createElement("text", {
    transform: "translate(87 473)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -35.66,
    y: 0
  }, "EU5")))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 48363"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#slider2_svg__a)",
    transform: "translate(-.003)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 104.713,
    height: 103.7,
    fill: "#fff",
    stroke: "#e3e3e3",
    "data-name": "Rectangle 26538",
    rx: 7,
    transform: "translate(815.29 64.5)"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Component 440 \\u2013 3"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 48361"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 48358",
    transform: "translate(826.787 77)"
  }, /*#__PURE__*/React.createElement("text", {
    fill: "#333",
    "data-name": "Brand A",
    fontFamily: "Poppins-Regular, Poppins",
    fontSize: 15,
    transform: "translate(21.521 16)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Brand A")), /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "#f1ad0f",
    "data-name": "Rectangle 26539",
    rx: 1,
    transform: "translate(0 4.954)"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 48359",
    transform: "translate(826.787 106)"
  }, /*#__PURE__*/React.createElement("text", {
    fill: "#333",
    "data-name": "Brand B",
    fontFamily: "Poppins-Regular, Poppins",
    fontSize: 15,
    transform: "translate(21.521 16)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Brand B")), /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    "data-name": "Rectangle 26540",
    rx: 1,
    transform: "translate(0 4.954)"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 48360",
    transform: "translate(826.787 136)"
  }, /*#__PURE__*/React.createElement("text", {
    fill: "#333",
    "data-name": "Brand C",
    fontFamily: "Poppins-Regular, Poppins",
    fontSize: 15,
    transform: "translate(21.521 16)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Brand C")), /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "#727272",
    "data-name": "Rectangle 26541",
    rx: 1,
    transform: "translate(0 4.954)"
  })))))), _text || (_text = /*#__PURE__*/React.createElement("text", {
    "data-name": "Brand Awareness Measured in Target Markets",
    fontFamily: "Poppins-Bold, Poppins",
    fontSize: 33,
    fontWeight: 700,
    transform: "translate(0 35)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Brand Awareness Measured in Target Markets"))), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    fill: "#666",
    "data-name": "Source: E2EvBrand Tracker TM",
    fontFamily: "Poppins-Regular, Poppins",
    fontSize: 22,
    transform: "translate(0 66)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Source: E2EvBrand Tracker "), /*#__PURE__*/React.createElement("tspan", {
    y: 0,
    baselineShift: 7.333,
    fontSize: 12.833
  }, "TM"))));
};
export default SvgSlider2;